import { useSyncExternalStore } from "react";

const createSessionStorageSubscribe =
  (key: string) => (callback: () => void) => {
    const handler = (e: StorageEvent) => {
      if (e.key === key) callback();
    };

    window.addEventListener("storage", handler);
    return () => {
      window.removeEventListener("storage", handler);
    };
  };

const createSessionStorageSnapshot = (key: string) => () => {
  return sessionStorage.getItem(key);
};

export const useSessionStorage = (key: string) => {
  return useSyncExternalStore(
    createSessionStorageSubscribe(key),
    createSessionStorageSnapshot(key)
  );
};
